// extracted by mini-css-extract-plugin
module.exports = {"link":"link_link__1dgGl"};